<div class="container-fluid mt-3">
  <!-- Filters Section - Hidden when used as nested component -->
  <section *ngIf="!isNestedComponent">
    <div class="row mb-3">
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Counsellor Type</mat-label>
          <mat-select [(value)]="counsellorsType" (selectionChange)="onCounsellorTypeChange($event)">
            <mat-option value="Active">Active Counsellors</mat-option>
            <mat-option value="All">All Counsellors</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Centre</mat-label>
          <mat-select [(ngModel)]="selectedCentre" multiple>
            <mat-option value="All Centres">All Centres</mat-option>
            <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
              {{ c.centreName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Date Range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate_local">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate_local">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="col-md-2">
        <button mat-raised-button color="accent" (click)="onSearch()" class="w-100" style="height: 56px;">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </div>
  </section>

  <!-- Local loading indicator (only used when nested to avoid global spinner) -->
  <div *ngIf="isNestedComponent && isLocalLoading" class="d-flex align-items-center gap-2 my-3">
    <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
    <span class="text-muted">Loading data...</span>
  </div>

  <!-- Table (always visible) -->
  <section>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z3 w-100">

      <!-- No -->
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>Sr.No.</th>
        <td mat-cell *matCellDef="let row;let i=index">{{ i+1 }}</td>
      </ng-container>

      <!-- Photo -->
      <ng-container matColumnDef="photo">
        <th mat-header-cell *matHeaderCellDef>Photo</th>
        <td mat-cell *matCellDef="let row">
          <img [src]="getPhoto(row.profileImages)"
               (error)="onImageError($event)"
               style="width:40px;height:40px;border-radius:50%; border: 1px solid" />
        </td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>Counsellor Name</th>
        <td mat-cell *matCellDef="let row">
          <b>{{ row.userName }}</b>
        </td>
      </ng-container>

      <!-- Centre -->
      <ng-container matColumnDef="centre">
        <th mat-header-cell *matHeaderCellDef>Alloted Centres</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.centre?.length <= 1">
            {{ row.centre.join(', ') }}
          </ng-container>
          <ng-container *ngIf="row.centre?.length > 1">
            <span *ngIf="!row.expanded">
              {{ row.centre.slice(0, 1).join(', ') }}
              <a style="color: #3f51b5; cursor: pointer;" (click)="toggleCentre(row)">
                + Read more
              </a>
            </span>
            <span *ngIf="row.expanded">
              {{ row.centre.join(', ') }}
              <a style="color: #3f51b5; cursor: pointer;" (click)="toggleCentre(row)">
                Read less
              </a>
            </span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Total Sessions -->
      <ng-container matColumnDef="totalSessionCount">
        <th mat-header-cell *matHeaderCellDef>Total Sessions</th>
        <td mat-cell *matCellDef="let row"><b>{{ formatZero(row.sessionCount + row.individualCount + row.followUpCount) }}</b></td>
      </ng-container>

      <ng-container matColumnDef="SessionObservedCount">
        <th mat-header-cell *matHeaderCellDef>Session Observed</th>
        <td mat-cell *matCellDef="let row"><b>{{ formatZero(row.sessionObserve)}}</b></td>
      </ng-container>

      <!-- Remark -->
      <ng-container matColumnDef="remark">
        <th mat-header-cell *matHeaderCellDef>Remark</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="isNestedComponent && !isViewMode">
            <input matInput
                   type="text"
                   [(ngModel)]="row.remark"
                   (ngModelChange)="onRemarkChange(row.userName, $event)"
                   placeholder="Add remark"
                   style="border: 1px solid #ccc; border-radius: 4px; padding: 4px 8px; width: 100%; min-width: 150px;">
          </ng-container>
          <ng-container *ngIf="isViewMode">
            {{ row.remark || '-' }}
          </ng-container>
          <ng-container *ngIf="!isNestedComponent">
            {{ row.remark || '-' }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="counsellorColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: counsellorColumns;"></tr>

    </table>
  </section>

  <!-- Session Count Report Section - hidden when nested to avoid redundant data & global spinner -->
  <ng-container *ngIf="!isNestedComponent">
    <br>
    <br>
    <hr>
    <br>
    <br>
    <section>
      <app-counselling-session-count-report></app-counselling-session-count-report>
    </section>
  </ng-container>
</div>

